const TOKEN_KEY = "access-token";

type TokenListener = (token: string | null) => void;

const listeners = new Set<TokenListener>();

export const getAccessToken = (): string | null => {
  const direct = localStorage.getItem(TOKEN_KEY);
  if (direct) {
    return direct;
  }

  return null;
};

export const setAccessToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
  listeners.forEach((listener) => {
    listener(token);
  });
};

export const clearAccessToken = () => setAccessToken(null);

export const subscribeToAccessToken = (listener: TokenListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
